export const MovieCatagories = [

    {
        catagorie_path: "top_rated_movies",
        catagorie_url: "https://api.themoviedb.org/3/movie/top_rated?",
        catagorie_titile: "Top Rated Movies",
        type:"movie"

    },
    {
        catagorie_path: "top_rated_series",
        catagorie_url: "https://api.themoviedb.org/3/tv/top_rated?",
        catagorie_titile: "Top Rated Series",
        type:"series"

    },
    {
        catagorie_path: "now_playing",
        catagorie_url: "https://api.themoviedb.org/3/movie/now_playing?",
        catagorie_titile: "Movies Now Playing",
        type:"movie"

    },
    {
        catagorie_path: "airing_today",
        catagorie_url: "https://api.themoviedb.org/3/tv/airing_today?",
        catagorie_titile: "Series Airing Today",
        type:"series"

    },
    
    

]